import PropTypes from 'prop-types';

import {
  ChildrenDefaultProps,
  ChildrenPropTypes,
} from '@/common/proptypes/Base/Children.proptypes';

export const IADefaultProps = {
  ...ChildrenDefaultProps,
  closeModal: () => null,
  handleDisableIA: () => null,
  item: {},
};

export const IAPropTypes = {
  ...ChildrenPropTypes,
  closeModal: PropTypes.func,
  handleDisableIA: PropTypes.func,
  item: PropTypes.shape({
    product: PropTypes.shape({
      brand: PropTypes.shape({
        name: PropTypes.string,
      }),
      image: PropTypes.shape({
        alt: PropTypes.string,
        url: PropTypes.string,
      }),
      name: PropTypes.string,
    }),
  }),
};
